import { IClassname } from '@/lib/shared/model/classname';

export const Stove = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.62354 26.5428V5.4572C1.62354 4.04565 2.76782 2.90137 4.17937 2.90137H27.8208C29.2324 2.90137 30.3767 4.04565 30.3767 5.4572V26.5428C30.3767 27.9544 29.2324 29.0987 27.8208 29.0987H4.17937C2.76782 29.0987 1.62354 27.9544 1.62354 26.5428Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.45728 11.6682C5.45728 12.7151 5.87317 13.7192 6.61347 14.4595C7.35376 15.1998 8.35782 15.6157 9.40476 15.6157C10.4517 15.6157 11.4558 15.1998 12.1961 14.4595C12.9363 13.7192 13.3522 12.7151 13.3522 11.6682C13.3522 10.6213 12.9363 9.61719 12.1961 8.87689C11.4558 8.1366 10.4517 7.7207 9.40476 7.7207C8.35782 7.7207 7.35376 8.1366 6.61347 8.87689C5.87317 9.61719 5.45728 10.6213 5.45728 11.6682Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9878 11.2345C16.9878 11.5702 17.0539 11.9025 17.1823 12.2126C17.3108 12.5227 17.499 12.8045 17.7364 13.0418C17.9737 13.2791 18.2555 13.4674 18.5655 13.5958C18.8756 13.7243 19.208 13.7904 19.5436 13.7904C19.8793 13.7904 20.2116 13.7243 20.5217 13.5958C20.8318 13.4674 21.1135 13.2791 21.3509 13.0418C21.5882 12.8045 21.7765 12.5227 21.9049 12.2126C22.0333 11.9025 22.0995 11.5702 22.0995 11.2345C22.0995 10.8989 22.0333 10.5666 21.9049 10.2565C21.7765 9.94638 21.5882 9.66463 21.3509 9.4273C21.1135 9.18997 20.8318 9.00171 20.5217 8.87326C20.2116 8.74482 19.8793 8.67871 19.5436 8.67871C19.208 8.67871 18.8756 8.74482 18.5655 8.87326C18.2555 9.00171 17.9737 9.18997 17.7364 9.4273C17.499 9.66463 17.3108 9.94638 17.1823 10.2565C17.0539 10.5666 16.9878 10.8989 16.9878 11.2345Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9878 21.7238C16.9878 22.0594 17.0539 22.3918 17.1823 22.7019C17.3108 23.012 17.499 23.2937 17.7364 23.531C17.9737 23.7684 18.2555 23.9566 18.5655 24.0851C18.8756 24.2135 19.208 24.2796 19.5436 24.2796C19.8793 24.2796 20.2116 24.2135 20.5217 24.0851C20.8318 23.9566 21.1135 23.7684 21.3509 23.531C21.5882 23.2937 21.7765 23.012 21.9049 22.7019C22.0333 22.3918 22.0995 22.0594 22.0995 21.7238C22.0995 21.3882 22.0333 21.0558 21.9049 20.7457C21.7765 20.4356 21.5882 20.1539 21.3509 19.9166C21.1135 19.6792 20.8318 19.491 20.5217 19.3625C20.2116 19.2341 19.8793 19.168 19.5436 19.168C19.208 19.168 18.8756 19.2341 18.5655 19.3625C18.2555 19.491 17.9737 19.6792 17.7364 19.9166C17.499 20.1539 17.3108 20.4356 17.1823 20.7457C17.0539 21.0558 16.9878 21.3882 16.9878 21.7238Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.85522 21.7238C6.85522 22.4017 7.1245 23.0517 7.60381 23.531C8.08312 24.0104 8.73321 24.2796 9.41106 24.2796C10.0889 24.2796 10.739 24.0104 11.2183 23.531C11.6976 23.0517 11.9669 22.4017 11.9669 21.7238C11.9669 21.046 11.6976 20.3959 11.2183 19.9166C10.739 19.4372 10.0889 19.168 9.41106 19.168C8.73321 19.168 8.08312 19.4372 7.60381 19.9166C7.1245 20.3959 6.85522 21.046 6.85522 21.7238Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2233 16.3997C26.0468 16.3997 25.9038 16.2567 25.9038 16.0802C25.9038 15.9037 26.0468 15.7607 26.2233 15.7607"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2234 16.3997C26.3999 16.3997 26.5429 16.2567 26.5429 16.0802C26.5429 15.9037 26.3999 15.7607 26.2234 15.7607"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2233 20.7923C26.0468 20.7923 25.9038 20.6493 25.9038 20.4728C25.9038 20.2963 26.0468 20.1533 26.2233 20.1533"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2234 20.7923C26.3999 20.7923 26.5429 20.6493 26.5429 20.4728C26.5429 20.2963 26.3999 20.1533 26.2234 20.1533"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2233 25.1849C26.0468 25.1849 25.9038 25.0419 25.9038 24.8654C25.9038 24.6889 26.0468 24.5459 26.2233 24.5459"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2234 25.1849C26.3999 25.1849 26.5429 25.0419 26.5429 24.8654C26.5429 24.6889 26.3999 24.5459 26.2234 24.5459"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
